import { useEffect, useState } from 'react';

import useFetchUserCount from '../hooks/usersCount';
import {
  ChevronLeftIcon,
  ChevronRightIcon
} from '@heroicons/react/24/solid';

const Pagination = (
  props: React.PropsWithChildren<{
    currentPage: number;
    pageChanged: (page: number) => unknown;
    itemsPerPage: number;
  }>
) => {
  const fetchUsersCount = useFetchUserCount();
  const [usersCount, setUsersCount] = useState<number>();
 
  useEffect(() => {
    fetchUsersCount().then((result) => {
      setUsersCount(result.data().count);
    });
  }, [fetchUsersCount]);
 
  if (usersCount === undefined) {
    return <div>Loading...</div>;
  }
 
  const totalPages = Math.floor(usersCount / props.itemsPerPage);
  const canGoBack = props.currentPage >= 1;
  const canGoNext = props.currentPage < totalPages;
 
  return (
    <div className={'flex flex-row justify-end align-center space-x-0.5'}>
      <button
        disabled={!canGoBack}
        onClick={() => props.pageChanged(props.currentPage - 1)}
        className='inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
      >
        <ChevronLeftIcon className="size-6"/>
        Previus
      </button>

      <span className='inline-flex items-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50'>{props.currentPage + 1} of {totalPages + 1}</span>
 
      <button
        disabled={!canGoNext}
        onClick={() => props.pageChanged(props.currentPage + 1)}
        className='inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
      >
        Next
        <ChevronRightIcon className="size-6"/>
      </button>
    </div>
  );
}

export default Pagination;